/* import __COLOCATED_TEMPLATE__ from './rounded-bubble.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();